<div class="header mb-3">
  <nav aria-label="progress mb-1" class="step-indicator">
      <ul class="steps">
          <li *ngFor="let step of steps"
              [class.complete]="step.completed"
              [class.active]="current.id === step.id">
            <ng-container *ngIf="showTitles">{{ step.title | translate }}</ng-container>
          </li>
       </ul>
  </nav>
</div>
<div class="content" *ngIf="current">
  <ng-container *ngComponentOutlet="current.component"></ng-container>
</div>
<div class="footer sticky-action-button sticky-down"
     [class.sticky-action-button]="hasAnyAction"
     [class.sticky-down]="hasAnyAction">
  <div class ="float-right">
    <button class="btn btn-secondary mr-2" type="button"
            [hidden]="!current.previousStepEnabled"
            (click)="previousStep()">
      {{ 'COMMON.wizard.backToPreviousStepButton' | translate }}
  </button>
  <button class="btn btn-secondary mr-2" type="button"
           [hidden]="!current.cancelStepEnabled"
          (click)="cancel()">
    {{ 'COMMON.wizard.cancelButton' | translate }}
  </button>
  <button *ngIf= "current.nextStepShow" class="btn btn-primary" type="button"
          [disabled]="!current.nextStepEnabled"
          (click)="nextStep()">
          {{ current.nextStepButtonLabel | translate }}
  </button>
</div>
</div>
